import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class MainBudgetingReportLine  {
    _originalTypeClassName = "zERP.BO.MainBudgetingReportLine";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
MainBudgetingReportLine.translate = translateService;
}
this.BudgetingAccount = null;
this.Description = null;
this.BudgetingAmount2 = null;
this.ActualAmount2 = null;
this.UsedPercentage2 = null;
this.BudgetingDifference = null;
this.BudgetingAmount1 = null;
this.ActualAmount1 = null;
this.UsedPercentage1 = null;
this.BudgetingAmount = null;
this.ActualAmount = null;
this.UsedPercentage = null;
this.GroupBy = null;
this.GroupPercentageDifference = null;
this.GroupCurrentPercentage = null;
this.GroupLastPercentage = null;
this.GroupTwoPercentage = null;
this.Code = null;
this.Name = null;
this.GroupCode = null;
this.GroupDescription = null;
this.BudgetingAmountWithAdjustments = null;
this.RequestedIncreaseAmount = null;
this.RequestedDecreaseAmount = null;
this.AmountAfterAdjustment = null;
this.TotalAdjustmentAmount = null;
this.AccountingCharge = null;
this.AccountingCredit = null;
this.InitialBudgetAmount = null;
this.MainBudgetingReportLineKey = null;
this._key = this.MainBudgetingReportLineKey = 0; 
}

static translate: TranslateService;
_key: any;
BudgetingAccount:any;
Description:any;
BudgetingAmount2:any;
ActualAmount2:any;
UsedPercentage2:any;
BudgetingDifference:any;
BudgetingAmount1:any;
ActualAmount1:any;
UsedPercentage1:any;
BudgetingAmount:any;
ActualAmount:any;
UsedPercentage:any;
GroupBy:any;
GroupPercentageDifference:any;
GroupCurrentPercentage:any;
GroupLastPercentage:any;
GroupTwoPercentage:any;
Code:any;
Name:any;
GroupCode:any;
GroupDescription:any;
BudgetingAmountWithAdjustments:any;
RequestedIncreaseAmount:any;
RequestedDecreaseAmount:any;
AmountAfterAdjustment:any;
TotalAdjustmentAmount:any;
AccountingCharge:any;
AccountingCredit:any;
InitialBudgetAmount:any;
private _MainBudgetingReportLineKey:any;
get MainBudgetingReportLineKey(): any {
    return this._MainBudgetingReportLineKey;
  }
set MainBudgetingReportLineKey(value: any) {
    this._MainBudgetingReportLineKey = value;
    this._key = value;
  }

static CalculatePercentages(lines: any): any{let groups = Joove.Common.cast(lines?.linq?.select((d) => d?.GroupBy)?.toArray()?.linq?.distinct()?.toArray(), "System.Collections.List");
for (let _igroup = 0; _igroup < (groups == null ? 0 : groups.length); _igroup++) {let group = groups[_igroup];let groupedLines = lines?.linq?.where((g) => g?.GroupBy == group)?.toArray();let GroupBudgetingCurrent = 0;let GroupBudgetingLast = 0;let GroupBudgetingTwo = 0;let GroupActualCurrent = 0;let GroupActualLast = 0;let GroupActualTwo = 0;for (let _iline = 0; _iline < (groupedLines == null ? 0 : groupedLines.length); _iline++) {let line = groupedLines[_iline];GroupBudgetingCurrent = Joove.Common.safeNumber(GroupBudgetingCurrent) + Joove.Common.safeNumber(line?.BudgetingAmount2);GroupBudgetingLast = Joove.Common.safeNumber(GroupBudgetingLast) + Joove.Common.safeNumber(line?.BudgetingAmount1);GroupBudgetingTwo = Joove.Common.safeNumber(GroupBudgetingTwo) + Joove.Common.safeNumber(line?.BudgetingAmount);GroupActualCurrent = Joove.Common.safeNumber(GroupActualCurrent) + Joove.Common.safeNumber(line?.ActualAmount2);GroupActualLast = Joove.Common.safeNumber(GroupActualLast) + Joove.Common.safeNumber(line?.ActualAmount1);GroupActualTwo = Joove.Common.safeNumber(GroupActualTwo) + Joove.Common.safeNumber(line?.ActualAmount);}console.info("Group Current: " + Joove.Common.safeNumber(GroupBudgetingCurrent));console.info("Group Last Year: " + Joove.Common.safeNumber(GroupBudgetingLast));let GroupCurrentPercentageCalc = (CLMS.Framework.Number.Equal(() => GroupBudgetingCurrent, () => 0) ? 0 : Joove.Common.safeNumber(GroupActualCurrent) / Joove.Common.safeNumber(GroupBudgetingCurrent));let GroupLastPercentageCalc = (CLMS.Framework.Number.Equal(() => GroupBudgetingLast, () => 0) ? 0 : Joove.Common.safeNumber(GroupActualLast) / Joove.Common.safeNumber(GroupBudgetingLast));let GroupTwoPercentageCalc = (CLMS.Framework.Number.Equal(() => GroupBudgetingTwo, () => 0) ? 0 : Joove.Common.safeNumber(GroupActualTwo) / Joove.Common.safeNumber(GroupBudgetingTwo));let GroupPercentageDifferenceCalc = (CLMS.Framework.Number.Equal(() => GroupBudgetingLast, () => 0) ? 0 : Joove.Common.safeNumber((Joove.Common.safeNumber(GroupBudgetingCurrent) - Joove.Common.safeNumber(GroupBudgetingLast))) / Joove.Common.safeNumber(GroupBudgetingLast));console.info("Group Budgeting Difference: " + Joove.Common.safeNumber(GroupPercentageDifferenceCalc));for (let _iline = 0; _iline < (groupedLines == null ? 0 : groupedLines.length); _iline++) {let line = groupedLines[_iline];line.GroupCurrentPercentage = GroupCurrentPercentageCalc;line.GroupLastPercentage = GroupLastPercentageCalc;line.GroupTwoPercentage = GroupTwoPercentageCalc;line.GroupPercentageDifference = GroupPercentageDifferenceCalc;}}
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.MainBudgetingReportLineKey == null || $this.MainBudgetingReportLineKey == 0;
            }


}